import {useMutation} from 'react-query';
import {patchPostLike} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUsePatchPostLikeProps {
  onSuccessAction?: () => void;
}
const usePatchPostLike = ({onSuccessAction}: IUsePatchPostLikeProps) => {
  const {
    isLoading,
    mutate: editLikePost,
    isSuccess,
  } = useMutation({
    mutationFn: (payload: IPostLikePayload) => {
      return patchPostLike(payload);
    },
    onSuccess: () => {
      onSuccessAction && onSuccessAction();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, editLikePost, isSuccess};
};

export default usePatchPostLike;
